export default "__VITE_ASSET__0a29b2e9__"